import { Paper, Text, Stack } from '@mantine/core'

export function InputSummary({ inputs, decisions }) {
  const hasData = (inputs?.length > 0) || (decisions?.length > 0)
  if (!hasData) return null

  return (
    <Stack gap="sm">
      <Text size="xs" c="dimmed" ff="Orbitron, sans-serif" fw={600} tt="uppercase" lts={1}>
        What You Shared
      </Text>
      {decisions?.map((d, i) => (
        <Paper key={`d-${i}`} p="md" className="glass" style={{ borderLeft: '3px solid rgba(0, 229, 255, 0.4)' }}>
          <Text size="xs" c="dimmed" ff="Rajdhani, sans-serif" fw={600} tt="uppercase" lts={1} mb={4}>
            {d.beatName}
          </Text>
          <Text size="sm" c="gray.3" fw={600}>{d.answer}</Text>
        </Paper>
      ))}
      {inputs?.map((input, i) => (
        <Paper key={`i-${i}`} p="md" className="glass" style={{ borderLeft: '3px solid rgba(0, 229, 255, 0.4)' }}>
          <Text size="xs" c="dimmed" ff="Rajdhani, sans-serif" fw={600} tt="uppercase" lts={1} mb={4}>
            {input.beatName}
          </Text>
          <Text size="sm" c="gray.4" fs="italic" mb={4}>{input.answer}</Text>
        </Paper>
      ))}
    </Stack>
  )
}
